import React from 'react';
import SecurityIncidentsSection from '../../../sections/AdminDashboard/SecurityFraud/SecurityIncidents';

const SecurityIncidents = () => {
  return <SecurityIncidentsSection />;
};

export default SecurityIncidents;

